import { Box, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import { useTranslation } from "react-i18next";

export interface BinLocationProps {
  bin: {
    aisle?: string;
    palletBay?: string;
    position?: string;
    shelf?: string;
    shelfBay?: string;
    storeBinCode?: string;
  } | null;
}

const LocationHeader = styled(Typography)(() => ({
  fontSize: 11
}));

const WarehouseLocation = styled(Box)(() => ({
  textAlign: "center"
}));

/**
 * Renders a bin location with headers.
 *
 * Accepts all types of bin locations and possible coordinates.
 */
export function BinLocation(props: BinLocationProps) {
  const { bin } = props;

  const { t } = useTranslation();

  if (!bin) {
    return null;
  }

  const { aisle, palletBay, shelfBay, shelf, position, storeBinCode } = bin;
  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: "repeat(4, 1fr)",
        alignItems: "center",
        width: "100%",
        gap: 1
      }}
    >
      {storeBinCode && (
        <WarehouseLocation>
          <LocationHeader variant="overline">{t("store bin")}</LocationHeader>
          <Typography variant="body1" noWrap>
            {storeBinCode}
          </Typography>
        </WarehouseLocation>
      )}
      {aisle && (
        <WarehouseLocation>
          <LocationHeader variant="overline">{t("aisle")}</LocationHeader>
          <Typography variant="body1" noWrap>
            {aisle}
          </Typography>
        </WarehouseLocation>
      )}
      {shelfBay && (
        <WarehouseLocation>
          <LocationHeader variant="overline">{t("shelf bay")}</LocationHeader>
          <Typography variant="body1" noWrap>
            {shelfBay}
          </Typography>
        </WarehouseLocation>
      )}
      {palletBay && (
        <WarehouseLocation>
          <LocationHeader variant="overline" noWrap>
            {t("pallet bay")}
          </LocationHeader>
          <Typography variant="body1" noWrap>
            {palletBay}
          </Typography>
        </WarehouseLocation>
      )}
      {shelf && (
        <WarehouseLocation>
          <LocationHeader variant="overline">{t("shelf")}</LocationHeader>
          <Typography variant="body1" noWrap>
            {shelf}
          </Typography>
        </WarehouseLocation>
      )}
      {position && (
        <WarehouseLocation>
          <LocationHeader variant="overline">{t("position")}</LocationHeader>
          <Typography variant="body1" noWrap>
            {position}
          </Typography>
        </WarehouseLocation>
      )}
    </Box>
  );
}
